import './VideosList.scss'

import { useRestoreScroll } from 'lib/util/scrollBehavior'
import VideoType from 'pages/Home/VideoType'
import React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

import VideoTile from './VideoTile'

export interface VideosListProps extends RouteComponentProps {
  videos: VideoType[]
}

export default withRouter(function VideosList(props: VideosListProps): JSX.Element {
  const { history, location, videos } = props
  useRestoreScroll(history, location)

  return (
    <div className="videos-list">
      {videos.map(video => (
        <VideoTile key={video.id} video={video} />
      ))}
      <div className="video-tile-container video-tile-container--flex-hack" />
    </div>
  )
})
